import { Injectable } from '@angular/core';
import {
    EntityCollectionServiceBase,
    EntityCollectionServiceElementsFactory,
} from 'ngrx-data';
import { NEVER, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from 'src/app/login/services/login-service.service';

import { ChoiceList } from './choice-list-dto';

@Injectable({
    providedIn: 'root',
})
export class ChoiceListService extends EntityCollectionServiceBase<ChoiceList> {
    private currentEntities: ChoiceList[];

    constructor(
        serviceElementsFactory: EntityCollectionServiceElementsFactory,
        private loginServce: LoginService
    ) {
        super('ChoiceList', serviceElementsFactory);
        // console.log('Choice List Service Constructed');

        this.entities$.subscribe(v => (this.currentEntities = v));

        loginServce.loggedOut$.subscribe(v => {
            console.log('User logged out, clearing cache');
            this.clearCache();
        });
    }

    getByID$ = {};

    getByID(
        objectStoreValue: string,
        idValue: string,
        gerritServiceValue: string
    ): Observable<ChoiceList> {
        if (idValue === undefined || idValue === null) {
            console.log('Asking for null choice list');
            return NEVER;
        }

        const foundEntity = this.currentEntities.find(v => v.id === idValue);

        if (foundEntity) {
            return of(foundEntity);
        } else {
            if (this.getByID$[idValue] == null) {
                this.getByID$[idValue] = super
                    .getWithQuery({
                        objectStore: objectStoreValue,
                        choiceList: idValue,
                        gerritService: gerritServiceValue,
                    })
                    .pipe(map(v => v[0]));
            }

            return this.getByID$[idValue];
        }
    }
}
